import { useEffect, useRef, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

let controlador = null

export function mostrarModalPendencias(pendencias, onClose) {
  controlador && controlador.mostrar(pendencias, onClose)
}

export function ocultarModalPendencias() {
  controlador && controlador.ocultar()
}

export default function ModalPendencias() {
  const [isOpen, setIsOpen] = useState(false)
  const [pendencias, setPendencias] = useState([])
  const onCloseRef = useRef(null)

  useEffect(() => {

    const fechar = () => {
      setIsOpen(false)
      const onClose = onCloseRef.current
      onCloseRef.current = null
      onClose && onClose()
    }

    controlador = {
      mostrar: (pendencias, onClose) => {
        setPendencias(pendencias || [])
        onCloseRef.current = onClose || null
        setIsOpen(true)
      },
      ocultar: fechar
    }

    return () => controlador = null // evitar fuga de memória se o objeto for destruido
  }, [])

  const handleOk = () => {
    controlador && controlador.ocultar()
  }

  return (
    <Modal isOpen={isOpen}>
      <ModalBody>
        <h2>Pendências</h2>
        {pendencias.map(pendencia => (
          pendencia.mensagem.map((mensagem, index) => (
            <div key={`${pendencia.tipo}-${index}`}>{mensagem}</div>
          ))
        ))}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleOk}>Ok</Button>
      </ModalFooter>
    </Modal>
  )
}
